export default __webpack_public_path__ + "static/media/mesha-logo.ec3c2393.png";